import React from 'react';
import PropTypes from 'prop-types';
import { Text, Pressable } from 'react-native';
import { Icon } from 'LocalGluons';
import { noop } from 'Utils';

import baseStyles from './ActionListItem.jss';

const ActionListItem = ({ title, iconName, onPress }) => (
    <Pressable style={baseStyles.container} onPress={onPress}>
        <Icon style={baseStyles.icon} name={iconName} />
        <Text style={baseStyles.itemName}>{title}</Text>
    </Pressable>
);

ActionListItem.defaultProps = {
    onPress: noop,
    iconName: ''
};

ActionListItem.propTypes = {
    title: PropTypes.string.isRequired,
    onPress: PropTypes.func,
    iconName: PropTypes.string
};

export { ActionListItem };
